﻿package com.mgacreative.hotelru.feature.housekeeping.di

import com.mgacreative.hotelru.feature.housekeeping.ui.HousekeepingViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getHousekeepingFeatureModule() = module {
    viewModel { HousekeepingViewModel(get(), get(), get(), getOrNull()) }
}

